<template>
  <page-table />
</template>
<script>
import PageTable from './components/table'
export default {
  name: 'ecom-awsReport-skuOutageStatistics',
  components: { PageTable },
}
</script>
